(function ($, Cobalt, undefined) {
    Cobalt.Shoutbox = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.User, name: "Cobalt.User"}];
        },
        latestCommentID: 0,
        cursorPosition: 0,
        emotes: new Array(),
        shoutboxes: null,
        shoutboxContainers: null,
        isStopped: false,
        getNewCommentsRoute: null,
        deleteMessageRoute: null,
        addMessageRoute: null,
        showShoutboxRoute: null,
        saveShowShoutboxPreferenceRoute: null,
        deleteIDs: null,
        showShoutbox: null,
        numComments: 20,
        timerFunctionName: "refreshShoutbox",
        template: '<% var isDeleted = CssClass.indexOf("deleted") > 0; %>\
                   <tr class="message <%= CssClass %>" data-id="<%= ID %>">\
                        <td class="message-time">[<%= DateCreated %>]&nbsp;</td>\
                        <td class="message-author">\
                            <div class="author"><a target="_blank" rel="noopener" href="<%= AuthorLink %>"><span class="<%= AuthorLinkCss %>"><%= AuthorName %></span></a>:</div> <%= Text %>\
                            <% if (CanModerate) { %>\
                                <div class="message-actions">\
                                    <ul class="message-actions-icons">\
                                        <% if (!isDeleted) { %>\
                                        <li>\
                                            <a class="message-action-delete tip" title="Delete" data-id="<%= ID %>" href="#">&nbsp;</a>\
                                        </li>\
                                        <% } \
                                           else { %>\
                                        <li>\
                                            <a class="message-action-add tip" title="Undelete" data-id="<%= ID %>" href="#">&nbsp;</a>\
                                        </li>\
                                        <% } %>\
                                    </ul>\
                                </div>\
                            <% } %>\
                        </td>\
                    </tr>',
        initialize: function () {
            var shoutboxContainers = $(".shoutbox-messages-container");
            var shoutboxes = $(".shoutbox-messages");
            if (shoutboxes.length > 0) {
                $(".shoutbox-messages").delegate('.message-action-delete, .message-action-add', "click", function (e) {
                    Cobalt.Shoutbox.bindModerationMethod($(this));
                    e.preventDefault();
                });

                shoutboxes.each(function (i, val) {
                    $(val).bind("scrollShoutbox", function (e, data) {
                        if (data) {
                            var elem = $(this)[0];
                            elem.scrollTop = data.scrollHeight;
                            elem.autoScrolledHeight = elem.scrollTop;
                            elem.autoScrolled = true;
                        }
                    });
                });

                shoutboxes.scroll(function (e) {
                    var elem = $(this)[0];

                    // The user is scrolling up the shoutbox.
                    if (elem.autoScrolledHeight !== undefined && (elem.scrollTop < elem.autoScrolledHeight)) {
                        elem.userScrolledHeight = elem.scrollTop;
                    }

                    // If the user has scrolled up the shoutbox previously, 
                    // and the current value indicates they're actually scrolled up more than the auto value, 
                    // keep it at the current value.
                    if (elem.userScrolledHeight !== undefined && elem.autoScrolledHeight !== undefined && (elem.userScrolledHeight < elem.autoScrolledHeight && elem.autoScrolled)) {
                        elem.scrollTop = elem.userScrolledHeight;
                        elem.autoScrolled = false;
                    }
                });

                var popout = $(".user-action-pop-out>a");
                popout.click(function (e) {
                    e.preventDefault();
                    Cobalt.Shoutbox.popOut();
                });

                if ($(".module.shoutbox.pop-out").length > 0) {
                    $("body").addClass("body-shoutbox-pop-out");
                }

                var li = $(".user-action-collapse");
                var anchor = $(li).find("a");
                var label = anchor.find("span");

                anchor.click(function () {
                    var collapseable = $(".expand-collapse .collapseable");
                    if ($(li).hasClass("user-action-collapse")) {
                        collapseable.hide();
                        Cobalt.Shoutbox.showShoutbox = false;
                        $(li).removeClass("user-action-collapse");
                        $(li).addClass("user-action-expand");
                        label.text("Expand");

                    }
                    else if ($(li).hasClass("user-action-expand")) {
                        collapseable.show();
                        Cobalt.Shoutbox.showShoutbox = true;
                        $(li).removeClass("user-action-expand");
                        $(li).addClass("user-action-collapse");
                        label.text("Collapse");
                    }

                    $.post(Cobalt.Shoutbox.saveShowShoutboxPreferenceRoute(Cobalt.Shoutbox.showShoutbox), null, function (results) {
                        Cobalt.Shoutbox.showShoutbox = results;
                        Cobalt.User.Preferences.ShowShoutbox = results;
                        Cobalt.User.savePreferences(true);
                    }, 'json');
                    return false;
                });

                var labelForRoleRequired = $("label[for='field-roleRequired']");
                var roleRequired = $("#field-roleRequired");
                var roleRequiredErrors = roleRequired.nextAll("span.field-errors");

                if (roleRequiredErrors.length <= 0 && roleRequired.val() == '') {
                    labelForRoleRequired.hide();
                    roleRequired.hide();
                }
                $("#field-isRoleRequired").click(function () {
                    if ($(this).attr("checked")) {
                        labelForRoleRequired.show();
                        roleRequired.show();
                    }
                    else {
                        labelForRoleRequired.hide();
                        roleRequired.hide();
                    }
                });

                Cobalt.Shoutbox.shoutboxes = shoutboxes;
                Cobalt.Shoutbox.shoutboxContainers = shoutboxContainers;
                var messageTextBox = $("input.shoutbox-form-message");
                if (messageTextBox.length > 0) {
                    messageTextBox.keydown(function () {
                        Cobalt.Shoutbox.cursorPosition = messageTextBox.caret().start;
                    }).keypress(function () {
                        Cobalt.Shoutbox.cursorPosition = messageTextBox.caret().start;
                    }).mousemove(function () {
                        Cobalt.Shoutbox.cursorPosition = messageTextBox.caret().start;
                    });
                }

                $("a#shoutbox-emotes-link").click(function () {
                    var emotesDiv = $('#shoutbox-emotes-div');
                    if (!emotesDiv.is(':visible')) {
                        emotesDiv.addClass('modal')
                            .css('top', $(this).position().top - ($(emotesDiv).height() + 15))
                            .css('left', $(this).position().left)
                            .css('position', 'absolute');
                        emotesDiv.show();
                    }
                    else {
                        emotesDiv.hide();
                    }
                    return false;
                });

                $("a.shoutbox-emotes-emote").each(function () {
                    var emoteTags = $(this).attr("data-emote");
                    if (emoteTags) {
                        var theEmotes = emoteTags.toString().split(", ");
                        var image = $(this).find("img").attr("src");
                        if (theEmotes) {
                            for (var i = 0; i < theEmotes.length; i++) {
                                var val = theEmotes[i];
                                var emote = val.toString().replace("'", "").replace("'", "");

                                var emoteObject = new Object();
                                emoteObject.key = emote;
                                emoteObject.value = image;

                                Cobalt.Shoutbox.emotes.push(emoteObject);
                            }
                        }
                    }
                });

                $("a.shoutbox-emotes-emote").each(function () {
                    var link = $(this);
                    link.click(function (e) {
                        var theEmotes = link.attr("data-emote").toString().split(",");
                        var emote = theEmotes[0].replace("'", "").replace("'", "");
                        var cursorPosition = Cobalt.Shoutbox.cursorPosition;
                        var currentMessage = messageTextBox.val().substr(0, cursorPosition + 1) + emote + messageTextBox.val().substr(cursorPosition);
                        messageTextBox.val(currentMessage);
                        $('#shoutbox-emotes-div').hide();
                        messageTextBox.focus();
                        e.preventDefault();
                    });
                });

                var messageContents;
                var messageForms = $(".shoutbox-form");
                if (messageForms.length > 0) {
                    $(messageForms).each(function (i, val) {
                        var messageForm = $(val).find("form");
                        messageForm.ajaxForm({
                            type: 'post',
                            beforeSubmit: function () {
                                $(messageForm).find("#field-submit").attr("disabled", "disabled");
                            },
                            success: function (results) {
                                var jsonResult = null;
                                try {
                                    jsonResult = JSON.parse(results);
                                }
                                catch (error) { }
                                if (jsonResult != null && jsonResult.Errors != undefined) {
                                    Cobalt.Forms.displayErrors(messageForm, jsonResult.Errors);
                                }
                                else {
                                    Cobalt.Shoutbox.addMessageResults(Cobalt.Shoutbox.shoutboxes, Cobalt.Shoutbox.shoutboxContainers, results, true);
                                    messageForm.find("#field-message").val("");
                                    Cobalt.Shoutbox.lastActivity = new Date();
                                    if (Cobalt.Shoutbox.isStopped) {
                                        Cobalt.Shoutbox.isStopped = false;
                                    }
                                }
                                $(messageForm).find("#field-submit").removeAttr("disabled");
                            },
                            error: function (XMLHttpRequest, textStatus, errorThrown) {
                                $(messageForm).find("#field-submit").removeAttr("disabled");
                                $("#shoutbox-form-errors").html(errorThrown);
                            }
                        });
                    });
                }

                if (Cobalt.Shoutbox.startingMessages) {
                    Cobalt.Shoutbox.addMessageResults(Cobalt.Shoutbox.shoutboxes, Cobalt.Shoutbox.shoutboxContainers, { DeletedIDs: [], Comments: Cobalt.Shoutbox.startingMessages }, true, true);
                }

                Cobalt.PollingThrottle.registerTimerFunction(Cobalt.Shoutbox.timerFunctionName, Cobalt.Shoutbox.refreshShoutbox, $(".shoutbox"));
            }
        },

        setStartingMessages: function (messages) {
            if (messages) {
                Cobalt.Shoutbox.startingMessages = messages;
            }
        },

        popOut: function () {
            Cobalt.PollingThrottle.removeTimerFunction(Cobalt.Shoutbox.timerFunctionName);
        },
        addMessageResults: function (shoutboxes, shoutboxContainers, results, scrollImmedietely, isInitialLoad) {
            
            if (results == null || (results.DeletedIDs.length == 0 && results.Comments.length == 0)) {                
                return;
            }

            var comments = results.Comments;
            comments.reverse();

            shoutboxContainers.each(function (i, container) {
                var shoutbox = $(container);                
                var shoutboxParent = shoutbox.parent();
                shoutbox.detach();
                $.each(comments, function (i, val) {
                                    
                    var existingRow = shoutbox.find("tr[data-id=" + val.ID + "]");                    
                    if (existingRow.length > 0) {                       
                        return;
                    }

                    for (var i = 0; i < Cobalt.Shoutbox.emotes.length; i++) {
                        while (val.Text.toString().indexOf(Cobalt.Shoutbox.emotes[i].key) >= 0) {
                            val.Text = val.Text.toString().replace(Cobalt.Shoutbox.emotes[i].key, "<img src=\"" + Cobalt.Shoutbox.emotes[i].value + "\" />");
                        }
                    }

                    var row = $.srender(Cobalt.Shoutbox.template, val);
                    shoutbox.append(row);

                    Cobalt.Shoutbox.latestCommentID = val.ID;
                    $(":hidden#field-latestCommentID").val(val.ID);

                    Cobalt.NiceDates.runNiceDates();
                });

                var messages = shoutbox.find("tr.message");
                while (messages.length >= Cobalt.Shoutbox.numComments) {
                    $(messages[0]).remove();
                    messages = shoutbox.find("tr.message");
                }

                shoutboxParent.append(shoutbox);
                var scrollHeight = Cobalt.Shoutbox.getShoutboxHeight();
                if (scrollImmedietely != true) {
                    $(shoutboxes).each(function (i, val) {
                        $(val).trigger("scrollShoutbox", { scrollHeight: scrollHeight });
                    });
                }
            });

            var scrollHeight = Cobalt.Shoutbox.getShoutboxHeight();
            if (scrollImmedietely == true) {
                $(shoutboxes).each(function (i, val) {
                    $(val).trigger("scrollShoutbox", { scrollHeight: scrollHeight + 100 });
                });
            }
            var ids = results.DeletedIDs;
            if (ids.length > 0) {
                var idsString = ids.join(',');
                if (idsString != Cobalt.Shoutbox.deleteIDs) {
                    $.each(ids, function (i, val) {
                        $(shoutboxes).find("tr.message[data-id='" + val + "']").remove();
                    });
                    Cobalt.Shoutbox.deleteIDs = idsString;
                }
            }

            if (!isInitialLoad) {
                Cobalt.triggerHtmlInsert(Cobalt.Shoutbox.shoutboxes);
            }

        },
        refreshShoutbox: function () {

            if (!Cobalt.Shoutbox.shoutboxContainers.is(":visible")) {
                return;
            }

            $.getJSON(Cobalt.Shoutbox.getNewCommentsRoute({ amount: Cobalt.Shoutbox.numComments, latestCommentID: Cobalt.Shoutbox.latestCommentID || undefined }), function (results) {
                Cobalt.Shoutbox.addMessageResults(Cobalt.Shoutbox.shoutboxes, Cobalt.Shoutbox.shoutboxContainers, results, false);
            });
        },
        bindModerationMethod: function (element) {
            var route = '';
            var messageID = parseInt($(element).attr("data-id"));
            var isAdd = $(element).hasClass("message-action-add");
            var isDelete = $(element).hasClass("message-action-delete")

            if (isAdd) {
                route = Cobalt.Shoutbox.addMessageRoute(messageID);
            }
            else if (isDelete) {
                route = Cobalt.Shoutbox.deleteMessageRoute(messageID);
            }

            if (messageID) {
                $.post(route, null, function (result) {
                    var li = $(element).parent("li");
                    var row = $("tr.message[data-id='" + messageID + "']");
                    if (li) {
                        if (isAdd) {
                            $(li).attr("title", L.Global.Forums.Delete());
                            $(row).removeClass("comment-deleted");
                            $(row).addClass("comment-normal");
                            $(element).removeClass("message-action-add");
                            $(element).addClass("message-action-delete");
                        }
                        else if (isDelete) {
                            $(li).attr("title", L.Global.Forums.Add());
                            $(row).removeClass("comment-normal");
                            $(row).addClass("comment-deleted");
                            $(element).removeClass("message-action-delete");
                            $(element).addClass("message-action-add");
                        }
                    }

                    $(element).unbind("click");
                    $(element).click(function () {
                        Cobalt.Shoutbox.bindModerationMethod($(this));
                        return false;
                    });
                }, "json");
            }
        },
        getShoutboxHeight: function () {
            var shoutboxContainers = Cobalt.Shoutbox.shoutboxContainers;
            var scrollHeight = shoutboxContainers.innerHeight();
            if ($.browser.msie) {
                scrollHeight = shoutboxContainers.height();
            }
            $(shoutboxContainers).each(function (i, val) {
                var currentHeight = $(val).innerHeight();
                if ($.browser.msie) {
                    currentHeight = $(val).height();
                }
                if (currentHeight > scrollHeight) {
                    scrollHeight = currentHeight;
                }
            });
            return scrollHeight;
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Shoutbox.js